module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46.15 36.537\"><defs><style> .check_icon { fill: none; stroke: #3219f5; stroke-width: 7px; } </style></defs><g id=\"check-icon\" data-name=\"check-icon\" transform=\"translate(-661.25 -718.777)\"><path id=\"check_icon_path\" data-name=\"Path 1\" class=\"check_icon\" d=\"M663.725,735.626l14.618,14.618,26.467-29.113\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/components/svgs/check.svg
// module id = ZCMT
// module chunks = 1